import axios from "axios";

const HOST = process.env.REACT_APP_HOST;

const signin = async (payload: any) => {
  const signinURL = `${HOST}/api/auth/login/admin`;
  const res = await axios.post(signinURL, payload);

  return res.data;
};

const signupNewAdmin = async (payload: any) => {
  const signupURL = `${HOST}/api/auth/register/admin`;
  const res = await axios.post(signupURL, payload);

  return res.data;
};

const forgotPassword = async (payload: any) => {
  const forgotPasswordURL = `${HOST}/api/auth/forgot_password/admin`;
  const res = await axios.post(forgotPasswordURL, payload);

  return res.data;
};

const updatePassword = async (payload: any) => {
  const updatePasswordURL = `${HOST}/api/auth/reset_password/admin`;
  const res = await axios.post(updatePasswordURL, payload);

  return res.data;
}

const changePassword = async (payload: any) => {
  const changePasswordURL = `${HOST}/api/auth/change_password/admin`;
  const res = await axios.post(changePasswordURL, payload);

  return res.data;
}

const verifyOTP = async (payload: any) => {
  const verifyURL = `${HOST}/api/auth/verify_otp/admin`;
  const res = await axios.post(verifyURL, payload);

  return res.data;
}

const resendOTP = async (payload: any) => {
  const verifyURL = `${HOST}/api/auth/verify_otp/admin`;
  const res = await axios.post(verifyURL, payload);

  return res.data;
}

export {
  signin,
  signupNewAdmin,
  forgotPassword,
  updatePassword,
  resendOTP,
  verifyOTP,
  changePassword
}